import { DefaultButton, Dropdown, TextField } from '@fluentui/react';
import { UserRolesModel } from '../../../../accounts/models/UserRolesInfo';
import { dropdownStyles } from '../../../../common/views/DefaultStyles';
import { OrderModel, ApproveOrderModel, OrderStatus } from '../../../models/OrderModel';
import { OrderUtils } from '../../shared/OrderUtils';

type ApproveOrderProps = {
    order: OrderModel;
    form: ApproveOrderModel;
    userRoles: UserRolesModel
    loading: boolean;
    onValueChange: (field: keyof ApproveOrderModel, value: any) => void;
    onSubmit: () => void;
}

export default function ApproveOrderView({
    order, form, userRoles, loading, onValueChange, onSubmit
}: ApproveOrderProps) {
    const isCanceled = () => {
        return form.status === OrderStatus.canceled || form.status === OrderStatus.declined;
    }

    const trackingPicker = () => {
        return <>
            <Dropdown
                label="Tracking"
                defaultSelectedKey={form.tracking}
                options={OrderUtils.getTrackingOptions()}
                onChange={(_, v) => onValueChange("tracking", v?.key)}
                styles={dropdownStyles} />
        </>;
    }

    const statusPicker = () => {
        return <>
            <Dropdown
                label="Status"
                selectedKey={form.status}
                options={OrderUtils.getStatusOptions()}
                styles={dropdownStyles}
                onChange={(_, v) => onValueChange("status", v?.key || 0)} />
        </>;
    }

    const reasonPicker = () => {
        return <>
            <Dropdown
                label="Reason"
                selectedKey={form.reason}
                options={OrderUtils.getReasonOptions()}
                styles={dropdownStyles}
                onChange={(_, v) => onValueChange("reason", v?.key || 0)} />
        </>;
    }

    const noteInput = () => {
        return <>
            <TextField
                label="Note"
                value={form.note}
                multiline rows={3}
                onChange={(_, v) => onValueChange("note", v || "")} />
        </>;
    }

    return <>
        <div>{trackingPicker()}</div>
        <div className="pt-10">{statusPicker()}</div>
        {isCanceled() && <div className="pt-10">{reasonPicker()}</div>}
        <div className="pt-10">{noteInput()}</div>

        {userRoles.isSalesSupervisor && !loading && <div className="pt-15 right">
            <DefaultButton onClick={onSubmit}>Save Change</DefaultButton>
        </div>}
    </>;
}